import { createContext } from 'react';

import type { FormWrapperRefProps } from '~interfaces/refProps';

interface FormContainerProps {
	disabled?: boolean;
	setDisabled?: React.Dispatch<React.SetStateAction<boolean>>;
	formRef?: React.RefObject<FormWrapperRefProps | null>;
}

// Don't initialized, this makes sure we can throw an error when the custom
// hook is not used in the provider.
// We can do this safely because we will get an error when we use it as
// provider

const FormContainerContext = createContext<FormContainerProps>(undefined!);
FormContainerContext.displayName = 'FormContainerContext';

export default FormContainerContext;
